import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class AddLostItem extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Add A Lost / Found Item in the Mobile APP</h2>

                <br/>

                 <p className='text-primary'>
                * Download the BOUNTE mobile app in the <a href='https://apps.apple.com/us/app/bounte/id1262003089?ls=1'>iTunes </a> or <a href= 'https://play.google.com/store/apps/details?id=com.bounte&hl=en_US'>Google Play </a> stores.  

              </p>
                
                <p className='text-primary'>1) Tap or click on the BOUNTE icon </p>
                <div className="text-center">
                    <img className='text-center' style={{width:70,height:75}} src='./images/bounteicon.png'  alt=''/> 
                </div> <br/> <br/>
                If you are logged in, you'll see the account menu screen.  if not, you will see the login screen.
                <br/>

                <p className='text-primary'>2) Tap or click "Add New Item" </p>

                    <div className="text-center">
                        <img className='text-center' style={{width:300,height:500}} src='./images/accountscreen.png'  alt=''/> 
                
                    
                    </div>

                <br/>

                <p className='text-primary'>3) Taking Photo. Focus the camera on the object that was found.  The BOUNTE app will need the object to be as close as possible to recognize and auto-tag the item. Click the blue button to take a photo.
                ie. In the example below, notice the item is a key and the rest of the items are not in the picture.  
                <br/> Note: Tap the "Flash: On" link at the top to toggle the flash on/off

                </p>

                <div className="text-center">
                    <img className='text-center' style={{width:300,height:500}} src='./images/takephoto.png'  alt=''/> 


                </div>

                <br/>

                <p className='text-primary'>4) Keywords. After taking the photo, the BOUNTE app will attempt to auto-fill the descriptions / tags for the item in the photo.  This can take up to five seconds, depending
                on the speed of the internet connection.  Once the item is identified the list of matching descriptions will be listed.  The checkboxes to the right can be used to include
                or exclude the item.  Click close to contine.
                 

                </p>

                <div className="text-center">
                    <img className='text-center' style={{width:300,height:500}} src='./images/picturedescription.png'  alt=''/> 


                </div>

                <br/>


                <p className='text-primary'>5) Enter Description, Keywords.</p>

                <p className='text-primary'><b>The "Item" and "Descr."</b> are the most important and required fields in the editor.  These fields are instrumental in how effective the BOUNTE app and website
                locate the items for users.  The more descriptive information that is added, the better the system will perform.  The ITEM field is the simple description such as "Key" or "Ring".  the DESCR field
                is the long description. i.e. <i> Black band with silver face.  IWC watch with inscription "Good Luck"</i></p>
                <br/>
                <p className='text-primary'>
                
                <b>LOCATION: </b> This is the location of where the item was found.  Room number or description of the location .  ie. 1017 or "lobby".
                <br/> <br/>
                <b>KEYWORDS: </b> Comma-sperated list of tags that describe the item.  ie. watch,black,silver,digital, wireless, etc... These are used for the BOUNTE web to locate items quickly using the search features.
                <br/> <br/>
                <b>ACTIVE: </b> This switch (on/off) determines if the item will be active in the system.  If not active, it will be used on the hotel's website. 
                <br/> <br/>
                <b>Publish: </b> This switch (on/off) will enable this item to be accessbile to hotel's website.  

 <br/> <br/>
                <b>IMAGE: </b> This is the image of item that was either just taken or last saved in the database.  Click "Add/Change" to take a different photo or select from a list of photos.  If the photo is different, 
                remember to update the keywords to match the item!

                <br/> <br/>
                <b>MAP: </b> The map will display the location of where the item was found.  This can be changed by entering a search keyword in the textbox.  This will reset the map's location.  Touch and hold the red 
                pin to lift and drag it to a specific location. 
          
                <br/> <br/>
           <b>Save: </b>  Tap "Save" to save the item into the hotel's central database.  It will now be accessible to the web and mobile devices for the hotel.  Make any changes and click save at any time to update.
           NOTE: The Web Venue portal can also add / update the lost item data. 


                </p>
                <div className="text-center">
                    <img className='text-center' style={{width:300,height:500}} src='./images/itemeditor.png' alt=''/> 
                </div>


                 <br/> 
                


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(AddLostItem);
